var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-base',{attrs:{"pacifier":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n        "+_vm._s(_vm.titleText)+"\n    ")]},proxy:true},{key:"subtitle",fn:function(){return [_vm._v("Choose a date and time below:")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }